// @module Convergence.featuredProd.featuredProd
define('Convergence.featuredProd.featuredProd.View'
,	[
	'convergence_featuredprod_featuredprod.tpl'
	
	,	'Backbone'
	,	'Convergence.featuredProd.featuredProd.Collection'
	,	'AjaxRequestsKiller'
	,	'Backbone.CollectionView'
	, 	'Utils'
	,	'Convergence.featuredProd.featuredProd.ItemCell.View'
	,	'Configuration'
    ]
, function (
	convergence_featuredprod_featuredprod_tpl
	
	,	Backbone
	,	featuredProdCollection
	,	AjaxRequestsKiller
	,	BackboneCollectionView
	, 	Utils
	,	featuredprodExtItemCellView
	,	Configuration

)
{
    'use strict';

	// @class Convergence.featuredProd.featuredProd.View @extends Backbone.View
	return Backbone.View.extend({

		template: convergence_featuredprod_featuredprod_tpl

	,	initialize: function (options) {
			this.application = options.container.getLayout().application;
			var self =this;
			this.collection = new featuredProdCollection();
			this.listenCollection();
			this.collection.on('reset', this.render, this);
			this.collection.fetch({
				killerId: AjaxRequestsKiller.getKillerId(),
		
			}).done(function () {
				self.render();
			}).fail(function (jqXhr, textStatus) {
				console.error('Error fetching collection:', textStatus);
				self.setLoading(false);
			})
		}

	,	listenCollection: function () {
			this.setLoading(true);
			
			this.collection.on({
				request: jQuery.proxy(this, 'setLoading', true),
				reset: jQuery.proxy(this, 'setLoading', false)
			});
		}

	,	setLoading: function (is_loading) {
			this.isLoading = is_loading;
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
		'Featured.Prod.Items': function () {
			return new BackboneCollectionView({
				collection: this.collection,
				viewsPerRow:
					this.itemsPerRow ||
					(Utils.isDesktopDevice() ? 3 : Utils.isTabletDevice() ? 2 : 1),
				childView: featuredprodExtItemCellView,
				childViewOptions: {
					application: this.application,

				},
				
			});
		}

		}

		//@method getContext @return Convergence.featuredProd.featuredProd.View.Context
	,	getContext: function getContext()
		{
			//@class Convergence.featuredProd.featuredProd.View.Context
			var ConfData = Configuration.get('featuredProd');
			// console.log('ConfData',ConfData);
			
			return {
				ConfData: ConfData
			};
		}
	});
});
